import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import firebase from 'firebase/app';
require("firebase/firestore");

class ResetPasswordDialog extends Component {
  state = {
    password1: '',
    password2: '',

    open: this.props.open,
    processing: false,
  };

  resetPassword = () => {
    this.startProcessing();
    firebase.auth().currentUser.updatePassword(this.state.password1).then(() => {
      this.stopProcessing();
      this.setState({ 
        password1: '', 
        password2: '' 
      });
      this.handleRequestClose();
    }).catch(error => {
      console.log(error);
      this.stopProcessing();
    });
  }

  startProcessing = () => {
    this.setState({ processing: true });
  }

  stopProcessing = () => {
    this.setState({ processing: false });
  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      this.setState({ open: nextProps.open, });
    }
  }

  render() {
    return (
      <Dialog
        onClose={this.handleRequestClose}
        open={this.state.open}
        disableBackdropClick={this.state.processing}
        disableEscapeKeyDown={this.state.processing}>
        <DialogTitle>Reset your password</DialogTitle>
        <DialogContent>
            <DialogContentText>
              Password must be at least 8 characters long.
            </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="password1"
            label="New password"
            type="password"
            fullWidth
            value={this.state.password1}
            onChange={ event => {
              this.setState({ password1: event.target.value });
            }}
          />
          <TextField
            margin="dense"
            id="password2"
            label="Re-enter new password"
            type="password"
            fullWidth
            value={this.state.password2}
            onChange={ event => {
              this.setState({ password2: event.target.value });
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={
              this.state.processing ||
              this.state.password1.length < 8 || 
              this.state.password2.length < 8 || 
              this.state.password1 !== this.state.password2
            }
            onClick={this.resetPassword} color="primary">
            SUBMIT
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ResetPasswordDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default ResetPasswordDialog;
